import * as Progress from "@radix-ui/react-progress";
import clsx from "clsx";

type ProgressBarProps = {
	value: number; // current progress value
	max?: number; // max value, default 100
	size?: "sm" | "md" | "lg"; // height sizes
	color?: "primary" | "success" | "danger"; // color variants
	className?: string;
	label: string;
};

const sizeClasses = {
	sm: "h-[8px]",
	md: "h-[16px]",
	lg: "h-[32px]",
};

const colorClasses = {
	primary: "bg-primary-200",
	success: "bg-green-200",
	danger: "bg-red-200",
};

const textColorClasses = {
	primary: "text-primary-700",
	success: "text-green-700",
	danger: "text-red-700",
};

export function ProgressBar({ value, max = 100, size = "md", color = "primary", className, label }: ProgressBarProps) {
	const clampedValue = Math.min(Math.max(value, 0), max);

	return (
		<Progress.Root
			className={clsx("relative w-full overflow-hidden rounded-full bg-slate-200", sizeClasses[size], className)}
			value={clampedValue}
			max={max}
			aria-valuemin={0}
			aria-valuemax={max}
			aria-valuenow={clampedValue}
		>
			<span className={clsx("absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 text-2xs font-bold", textColorClasses[color])}>{label}</span>
			<Progress.Indicator
				className={clsx("h-full transition-all duration-300 ease-in-out", colorClasses[color])}
				style={{ width: `${(clampedValue / max) * 100}%` }}
			/>
		</Progress.Root>
	);
}
